import { useProfileData } from "../../../hooks/useProfileData";

const useIsOwn = ({ authorId, isAuthorIdLoading }: { authorId?: number; isAuthorIdLoading: boolean }) => {
  const {
    data: { id: userId },
    isLoading: isProfileDataLoading,
  } = useProfileData();

  return {
    isOwn: userId === authorId,
    isLoading: isProfileDataLoading || isAuthorIdLoading,
  };
};

export default useIsOwn;
